import { useContext, useState } from "react";

import { CButton, CInput } from "src/common/components/controls";

import { SearchContext } from ".";

export const SearchGoodsSection = () => {
  //#region Data
  const [input, setInput] = useState("");

  const { setSearchValue } = useContext(SearchContext);
  //#endregion

  //#region Event
  const onChange = (value) => {
    setInput(value);
  };

  const goToSearch = () => setSearchValue(input);
  //#endregion

  //#region Render
  return (
    <div className="flex flex-row items-end">
      <CInput
        label="Tìm kiếm mặt hàng"
        className="flex-1"
        placeholder="Nhập mã hoặc tên HH"
        value={input}
        onChange={onChange}
        onEnter={goToSearch}
      />
      <CButton className="mr-0" onClick={goToSearch}>
        Tìm kiếm
      </CButton>
    </div>
  );
  //#endregion
};
